import React, { useEffect, useState } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import axios from 'axios';
import API_BASE_URL from '../../api/config';

const useScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};

const CollegeActivities = () => {
  useScrollToTop();
  const controls = useAnimation();
  const [ref, inView] = useInView({ triggerOnce: true });
  const [images, setImages] = useState([]);

  useEffect(() => {
    if (inView) controls.start('visible');
  }, [controls, inView]);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/activity_ethiccraft/read_isShown`)
      .then((res) => {
        const arr = Array.isArray(res.data) ? res.data : (res.data.data || []);
        // Ensure you have at least 4 images to fill the grid structure
        if (arr.length >= 4) {
          setImages(arr);
        } else {
          // Fallback or handle cases with fewer than 4 images
          console.warn("Less than 4 images fetched for CollegeActivities. Consider providing more.");
          setImages(arr); // Still set them if less, CSS will adapt
        }
      })
      .catch((err) => console.error('Failed to fetch images', err));
  }, []);

  const variants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  const getSizeClass = (index) => {
    // This pattern repeats: big, small, small, big
    const sizePattern = ['big', 'small', 'small', 'big'];
    return sizePattern[index % sizePattern.length];
  };

  const getImageAnimation = (index) => {
    const base = {
      opacity: 0,
    };
    // Different animation directions for each image in the pattern
    const directions = [
      { x: -50 }, // First image (top-left) from left
      { y: 50 },  // Second image (bottom-left) from bottom
      { x: 50 },  // Third image (top-right) from right
      { y: -50 }  // Fourth image (bottom-right) from top
    ];
    
    // Adjusted delay for better sequential reveal
    const delay = 0.15 * index; 

    return { 
        initial: { ...base, ...directions[index % directions.length] }, 
        animate: { 
            opacity: 1, 
            x: 0, 
            y: 0, 
            transition: { duration: 0.8, ease: "easeOut", delay: delay } 
        } 
    };
  };

  return (
    <motion.div
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={variants}
      className="activities-about"
    >
      <div className="image-grid">
        <div className="grid-column">
          {images.slice(0, 2).map((img, i) => {
            const { initial, animate } = getImageAnimation(i);
            return (
              <motion.img
                key={img.id || i} // Use img.id if available, fallback to i
                src={`https://ethiccraft.org/${img.image}`}
                initial={initial}
                animate={animate}
                className={`grid-image ${getSizeClass(i)}`}
              />
            );
          })}
        </div>
        <div className="grid-column">
          {images.slice(2, 4).map((img, i) => {
            // Adjust index for animation to be unique per image
            const globalIndex = i + 2; 
            const { initial, animate } = getImageAnimation(globalIndex);
            return (
              <motion.img
                key={img.id || globalIndex} // Use img.id if available, fallback to globalIndex
                src={`https://ethiccraft.org/${img.image}`}
                initial={initial}
                animate={animate}
                className={`grid-image ${getSizeClass(globalIndex)}`}
              />
            );
          })}
        </div>
      </div>

      <div className="content-section">
        <h2 className="section-title">
          <span className="welcome-title">Ethiccraft Activities</span>
        </h2>
        <p className="Activities-description">
          Ethiccraft Club organizes dynamic activities in colleges to inspire students with values and ethics. Our events include cultural fests, workshops, seminars, and leadership programs that encourage youth to build character and make ethical choices.
          <br />
          These activities create a vibrant space where students discuss real-life challenges, engage in thought-provoking sessions, and participate in initiatives that promote social good and personal growth. Through these engaging experiences, students develop leadership skills, connect with peers, and gain fresh perspectives on ethical living.
        </p>
        <p className="Activities-description">
          🏫 Join Ethiccraft in your college and be part of the youth movement for values!
        </p>
      </div>
    </motion.div>
  );
};

export default CollegeActivities;